"use strict";
/* global Game */ document.addEventListener("DOMContentLoaded", function() {
    var updateField = function updateField() {
        var state = game.getState();
        var rows = gameField.querySelectorAll(".field-row");
        for(var i = 0; i < 4; i++){
            var cells = rows[i].querySelectorAll(".field-cell");
            for(var j = 0; j < 4; j++){
                var value = state[i][j];
                cells[j].textContent = value === 0 ? "" : value;
                cells[j].className = value === 0 ? "field-cell" : "field-cell field-cell--".concat(value);
            }
        }
    };
    var updateScore = function updateScore() {
        gameScore.textContent = game.getScore();
    };
    var updateButton = function updateButton() {
        if (game.getStatus() === "idle") {
            gameButton.textContent = "Start";
            gameButton.className = "button start";
        } else {
            gameButton.textContent = "Restart";
            gameButton.className = "button restart";
        }
    };
    var updateMessages = function updateMessages() {
        var gameStatus = game.getStatus();
        messageLose.classList.add("hidden");
        messageWin.classList.add("hidden");
        messageStart.classList.add("hidden");
        if (gameStatus === "idle") messageStart.classList.remove("hidden");
        else if (gameStatus === "lose") messageLose.classList.remove("hidden");
        else if (gameStatus === "win") messageWin.classList.remove("hidden");
    };
    var updateUI = function updateUI() {
        updateField();
        updateScore();
        updateButton();
        updateMessages();
    };
    var game = new Game();
    var gameField = document.querySelector(".game-field");
    var gameScore = document.querySelector(".game-score");
    var gameButton = document.querySelector(".button.start");
    var messageLose = document.querySelector(".message-lose");
    var messageWin = document.querySelector(".message-win");
    var messageStart = document.querySelector(".message-start");
    gameButton.addEventListener("click", function() {
        if (game.getStatus() === "idle") game.start();
        else game.restart();
        updateField();
        updateScore();
        updateButton();
        updateMessages();
    });
    document.addEventListener("keydown", function(event) {
        if (game.getStatus() !== "playing") return;
        switch(event.key){
            case "ArrowLeft":
                game.moveLeft();
                break;
            case "ArrowRight":
                game.moveRight();
                break;
            case "ArrowUp":
                game.moveUp();
                break;
            case "ArrowDown":
                game.moveDown();
                break;
            default:
                return;
        }
        updateField();
        updateScore();
        updateButton();
        updateMessages();
    });
    var startX = 0;
    var startY = 0;
    document.addEventListener("touchstart", function(event) {
        if (event.target.closest(".game-field")) event.preventDefault();
        var touch = event.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;
    });
    document.addEventListener("touchmove", function(event) {
        if (event.target.closest(".game-field")) event.preventDefault();
    });
    document.addEventListener("touchend", function(event) {
        if (event.target.closest(".game-field")) event.preventDefault();
        if (!startX || !startY || game.getStatus() !== "playing") return;
        var touch = event.changedTouches[0];
        var diffX = touch.clientX - startX;
        var diffY = touch.clientY - startY;
        if (Math.abs(diffX) < 30 && Math.abs(diffY) < 30) return;
        if (Math.abs(diffX) > Math.abs(diffY)) diffX > 0 ? game.moveRight() : game.moveLeft();
        else diffY > 0 ? game.moveDown() : game.moveUp();
        updateUI();
        startX = 0;
        startY = 0;
    });
    updateField();
    updateScore();
    updateButton();
    updateMessages();
});

//# sourceMappingURL=index.601092b8.js.map
